import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  resetAndCloseSearchAction
} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.store";
import {useAppSelector} from "../../../../redux/hooks";
import {
  getIsMySongsPageSearchFocused,
  getMySongsPageSearchValue
} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.selectors";

export interface ISongSearchControlResetButtonLogic {
  isResetButtonAvailable: boolean,
  handleSearchInputReset: () => void,
}

export const useSongSearchControlResetButtonLogic = (): ISongSearchControlResetButtonLogic => {
  const isSearchFocused = useAppSelector(getIsMySongsPageSearchFocused);

  const searchValue = useAppSelector(getMySongsPageSearchValue);

  const isResetButtonAvailable: boolean = (
    isSearchFocused
    || searchValue.trim().length > 0
  );

  const dispatch = useDispatch();

  const handleSearchInputReset = useCallback(() => {
    dispatch(resetAndCloseSearchAction());
  }, [dispatch]);
  return {
    isResetButtonAvailable,
    handleSearchInputReset,
  };
}
